import React, { useEffect } from 'react'
import { seeUserRanking } from '../../actions/userActions'
import { connect } from 'react-redux'
import inMemoryJWT from '../../auth/inMemoryJwt';


/* const RankingUser = ({ userRanking, isLoadingUserRanking, seeUserRanking, history }) => {

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeUserRanking()
        })
    }, [])

    console.log()
    return (
        <>
            {!isLoadingUserRanking &&
                userRanking.map((ranking, index) => (
                    index < 4 &&
                    <img alt="img" className={ranking.colored ? 'img-profile-icon-active' : 'img-profile-icon'} src={ranking.image.url}></img>
                ))
            }
        </>
    )
} */

const RankingUser = ({ userRanking, isLoadingUserRanking, userInfo, seeUserRanking, history }) => {

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeUserRanking(userInfo._id)
        })
    }, [userInfo])

    const imgRang = (userRanking) => {
        var count = 4
        var indexRang = 0
        for (let index = 0; index < userRanking.length; index++) {
            if (userRanking[index].current || (index ===(userRanking.length - 4))) {
                indexRang = index
                break;
            }
            console.log()
        }
        console.log()
        if (userRanking.length >= 3)
            return <>
                < img alt="img" className={userRanking[indexRang].colored ? 'img-profile-icon-active' : 'img-profile-icon'} src={userRanking[indexRang].image.url} ></img>
                < img alt="img" className={userRanking[indexRang + 1].colored ? 'img-profile-icon-active' : 'img-profile-icon'} src={userRanking[indexRang + 1].image.url} ></img>
                < img alt="img" className={userRanking[indexRang + 2].colored ? 'img-profile-icon-active' : 'img-profile-icon'} src={userRanking[indexRang + 2].image.url} ></img>
                < img alt="img" className={userRanking[indexRang + 3].colored ? 'img-profile-icon-active' : 'img-profile-icon'} src={userRanking[indexRang + 3].image.url} ></img>
            </>
        else
            return null
    }

    if (isLoadingUserRanking)
        return null
    else
        return (
            <>
                { imgRang(userRanking)}
            </>
        )
}
const mapStateToProps = (state) => {
    return {
        isLoadingUserRanking: state.userInfo.isLoadingUserRanking,
        userRanking: state.userInfo.userRanking
    }
}
export default connect(mapStateToProps, { seeUserRanking })(RankingUser)
